import countriesJSON from "./countries.json";
export const getCountries = () => {
    return countriesJSON;
};
export const getCountry = (code) => {
    const country = countriesJSON.find((country) => country.code === code);
    if (!country) {
        console.error(`content/getCountry: country not found for code ${code}`);
    }
    return country;
};
export const isValidCountry = (code) => {
    if (!code) {
        return false;
    }
    return !!countriesJSON.find((country) => country.code === code.toUpperCase());
};
